import { useEffect, useState } from "react";
import styles from "./Bank.module.css";
import { useDispatch, useSelector } from "react-redux";

import { Page } from "../../../helbest";

import { _Cart_Clean } from "../../../store/actions/cart_actions";

import { useLocation } from "react-router-dom";
import { useCheckoutCompleteMutation } from "../../../saleor/api";
import {
  set_checkout_id,
  set_transaction_id,
} from "../../../store/actions/login_actions";
import { _Clear_note_for_checkout } from "../../../store/actions/checkout_actions";
import { calculator } from "../../../base/utils";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import ReverseProgressBar from "./ProgressBar/ReverseProgressBar";
import { useTranslation } from "react-i18next";
import { getNotifications } from "../../../request/api/real-api/notification";
import { _set_initial_data } from "../../../store/actions/notification_actions";
import { Button } from "antd";
import { ReactComponent as DoneIcon } from "../../../assets/images/base/done.svg";

const DoneBank = () => {
  const { t } = useTranslation();

  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const login = store?.Login || {};
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [orderNumber, setOrderNumber] = useState(null);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const query = new URLSearchParams(location.search);
  const [checkoutCompleteMutation] = useCheckoutCompleteMutation();

  const checkoutId = query.get("checkout_id");
  const pspReference = query.get("psp_reference");
  const wallet = query.get("is_wallet_charge");
  const orderNumberWallet = query.get("orderNumber");
  const effectiveChannel = store.Login.pendingChannel || store.Login.channel;
  
  const check_user = () => {
    if (!store.Login.is_login) {
      navigate("/");
    }
  };

  useEffect(() => {
    check_user();
  }, []);

  useEffect(() => {
    if (wallet !== "true")
      checkoutCompleteMutation({
        variables: {
          id: checkoutId,
          metadata: store.Checkout.note
            ? [{ key: "Note", value: store.Checkout.note }]
            : [],
        },
        onCompleted: (response) => {
          if (response.checkoutComplete.errors.length === 0) {
            setLoading(false);
            dispatch(_Cart_Clean());
            dispatch(_Clear_note_for_checkout());
            calculator();
            setOrderNumber(response.checkoutComplete.order.number);
          } else {
            navigate(`/payment/error?psp_reference=${pspReference}`);
          }
        },
        onError: () => {
          navigate(`/payment/error?psp_reference=${pspReference}`);
        },
      });

    return () => {
      dispatch(set_transaction_id(""));
      dispatch(set_checkout_id({ checkout_id: "" }));
    };
  }, []);

  return (
    <Page
      className="page-bank"
      title="Payment Result"
      back={true}
      address="/"
      customHeader={<HeaderBack title={t("payment.result")} url={"/"} />}
      mobileContainer
      headerFix
      logo
      showFooter={false}
      hasFloat={false}
    >
      <div className={styles.container}>
        {loading && wallet !== "true" ? (
          <div className={styles.Traditional} />
        ) : (
          <div className={styles.content}>
            <DoneIcon className={styles.paymentImage} />
            <h4 className={styles.paymentSuccessMessage}>
              {t("payment.done.main")}
            </h4>
            <div className={styles.paymentTextContainer}>
              <p className={styles.paymentText} style={{ marginBottom: 0 }}>
                {t("payment.done.thanks")}
              </p>

              {wallet !== "true" ? (
                <>
                  <p className={styles.paymentText}>
                    {t("payment.done.transaction")}: {pspReference}
                  </p>
                  <p className={styles.paymentText}>
                    {t("payment.done.number")}: {orderNumber}
                  </p>
                </>
              ) : (
                <p className={styles.paymentText}>
                  {t("payment.done.number")}: {orderNumberWallet}
                </p>
              )}
            </div>
            <div className={styles.Footer}>
              <ReverseProgressBar
                duration={10000}
                onClick={() => {
                  const interest = [];
                  let currentInterest = "public-gamll";
                  interest.push(currentInterest);

                  if (login.cid) {
                    currentInterest = `${currentInterest}-${login.cid}`;
                    interest.push(currentInterest);
                  }

                  if (login.cpid) {
                    currentInterest = `${currentInterest}-${login.cpid}`;
                    interest.push(currentInterest);
                  }

                  if (effectiveChannel) {
                    currentInterest = `${currentInterest}-${effectiveChannel}`;
                    interest.push(currentInterest);
                  }
                  
                  setNotificationLoading(true);
                  getNotifications({ interests: interest }).then((res) => {
                    setNotificationLoading(false);
                    if (res.code === 200) {
                      dispatch(_set_initial_data(res.data));
                      navigate("/");
                    } else {
                      navigate("/");
                    }
                  });
                }}
                onComplete={() => {
                  const interest = [];
                  let currentInterest = "public-gmall";
                  interest.push(currentInterest);

                  if (login.cid) {
                    currentInterest = `${currentInterest}-${login.cid}`;
                    interest.push(currentInterest);
                  }

                  if (login.cpid) {
                    currentInterest = `${currentInterest}-${login.cpid}`;
                    interest.push(currentInterest);
                  }

                  setNotificationLoading(true);
                  getNotifications({ interests: interest }).then((res) => {
                    setNotificationLoading(false);
                    if (res.code === 200) {
                      dispatch(_set_initial_data(res.data));
                      navigate("/");
                    } else {
                      navigate("/");
                    }
                  });
                }}
                loading={notificationLoading}
                content={t("common.homepage")}
              />

              <Button
                style={{ width: "100%" }}
                type="default"
                onClick={() => {
                  const interest = [];
                  let currentInterest = "public-gmall";
                  interest.push(currentInterest);

                  if (login.cid) {
                    currentInterest = `${currentInterest}-${login.cid}`;
                    interest.push(currentInterest);
                  }

                  if (login.cpid) {
                    currentInterest = `${currentInterest}-${login.cpid}`;
                    interest.push(currentInterest);
                  }

                  setNotificationLoading(true);
                  getNotifications({ interests: interest }).then((res) => {
                    setNotificationLoading(false);
                    if (res.code === 200) {
                      dispatch(_set_initial_data(res.data));
                      navigate("/my-orders/");
                    } else {
                      navigate("/my-orders/");
                    }
                  });
                }}
              >
                {t("detailmodel.order_details")}
              </Button>
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};

export default DoneBank;
